<template>
    <div class="price-section">
        <div class="price-section-title">
            {{ t({ key: 'shared.seating' }) }}
        </div>

        <div class="price-section-rows">
            <template v-for="seat in selectedSeats" :key="seat.Id">
                <div
                    v-if="
                        seat?.PriceBreakdown?.BookingFee &&
                        seat?.PriceBreakdown?.SupplierPrice
                    ">
                    <PriceSpecificationRow
                        :price="seat?.PriceBreakdown?.SupplierPrice"
                        :description="getSeatDescription(seat)" />
                    <PriceSpecificationRow
                        class="sub"
                        :price="seat?.PriceBreakdown?.BookingFee"
                        :description="t({ key: 'checkout.booking_fee' })" />
                </div>
                <PriceSpecificationRow
                    v-else
                    :price="seat.Price"
                    :description="getSeatDescription(seat)" />
            </template>
            <PriceSpecificationRow
                class="total"
                :price="totalPrice"
                :description="t({ key: 'checkout.total_price_seating' })" />
        </div>
        <Divider color="lightGrey" bottomMargin="xl" topMargin="xl" thickness="1" />
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import PriceSpecificationRow from '../PriceSpecificationRow.vue';
    import { FlightProduct } from '@/api/Cart/cart.interfaces';
    import {
        getAllSeatsForFlightProduct,
        getSeatDescription,
        getSeatingTotalPriceForFlightProduct,
    } from '@/helpers/seating';
    import { t } from '@shared/helpers/translation';
    import Divider from '@ui/components/Divider/Divider.vue';

    export default defineComponent({
        name: 'PriceSpecificationGordianSeating',
        components: {
            Divider,
            PriceSpecificationRow,
        },
        methods: { t, getSeatDescription },
        props: {
            product: {
                type: Object as PropType<FlightProduct>,
                required: true,
            },
        },
        setup({ product }) {
            const selectedSeats = computed(() => getAllSeatsForFlightProduct(product));

            const totalPrice = computed(() => getSeatingTotalPriceForFlightProduct(product));

            return {
                totalPrice,
                selectedSeats,
            };
        },
    });
</script>
